/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "paymentbalances": {
        "nested": {
          "ExternalSource": {
            "fields": {
              "name": {
                "type": ".squareup.paymentbalances.ExternalSource.Name",
                "id": 1,
                "rule": "optional"
              },
              "id": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              }
            },
            "nested": {
              "Name": {
                "values": {
                  "PAYMENTS_CAPTURE": 3,
                  "PAYMENTS_REFUND": 2,
                  "CAPITAL": 4,
                  "CHECK": 5,
                  "BILLING": 6,
                  "BILLING_REFUND": 7,
                  "SQWEB_ADJUSTMENT": 10,
                  "SQWEB_HOLD": 11,
                  "SQWEB_INCENTED_PAYMENT": 12,
                  "SQWEB_REDEMPTION": 13,
                  "SQWEB_SEED": 14,
                  "SQWEB_FREE_PROCESSING": 16,
                  "SQWEB_PAYOUT": 17,
                  "SQWEB_MCA": 18,
                  "SQWEB_SQPLUS_BILL": 19,
                  "SQWEB_TRANSFER": 20,
                  "SQWEB_CORRECTION": 21,
                  "SQWEB_GUARANTEED_PAYMENT": 22,
                  "SQWEB_LEDGER_ENTRY": 23,
                  "SQWEB_CARD_REFUND": 24,
                  "SQWEB_MERCHANT": 25,
                  "SQWEB_BANK_ACCOUNT": 26,
                  "SQWEB_FREEZE": 27,
                  "SQWEB_SUSPICION": 28,
                  "SQWEB_BANK_SETTLEMENT_RETURN": 50,
                  "SQWEB_SUBSCRIPTION": 15,
                  "SQWEB_SUBSCRIPTION_REFUND": 29,
                  "SQWEB_SUBSCRIPTION_PAID_REFUND": 52,
                  "SQWEB_BLACKLIST": 51,
                  "LEDGER_MCA": 30,
                  "LEDGER_RETURNED_LEDGER_ENTRY": 31,
                  "LEDGER_BANK_SETTLEMENT_ENTRY": 32,
                  "LEDGER_BANK_SETTLEMENT_RETURN": 33,
                  "LEDGER_HOLD": 34,
                  "LEDGER_UNDO": 35,
                  "LEDGER_DEPOSIT_FEE": 36,
                  "LEDGER_DISPUTE": 37,
                  "LEDGER_FEE": 53,
                  "MONEY_TRANSFER": 54,
                  "LEDGER_THIRD_PARTY_FEE": 55,
                  "LEDGER_ESCHEATMENT": 56,
                  "PAYMENTS": 0,
                  "DEPRECATED_BANK": 1,
                  "NET_ZERO_OFFSET": 57,
                  "SOLIDSHOP": 58,
                  "CAPTURE_BALANCE_PAYMENT": 61,
                  "COMPLETE_BALANCE_PAYMENT": 59,
                  "DEPOSIT": 60,
                  "FAIL_DEPOSIT": 62,
                  "BOOKKEEPER": 63,
                  "ISSUED_CARD_AUTHORIZATION": 64,
                  "ISSUED_CARD_AUTHORIZATION_ADVICE": 71,
                  "ISSUED_CARD_CAPTURE": 65,
                  "ISSUED_CARD_CHARGEBACK": 82,
                  "ISSUED_CARD_CHARGEBACK_REVERSAL": 83,
                  "ISSUED_CARD_DIRECT_CAPTURE": 66,
                  "ISSUED_CARD_DIRECT_FORCE_CAPTURE": 72,
                  "ISSUED_CARD_REFUND": 68,
                  "ISSUED_CARD_REFUND_REVERSAL": 73,
                  "ISSUED_CARD_REVERSAL": 67,
                  "ISSUED_CARD_REWARD": 84,
                  "ISSUED_CARD_REWARD_REVERSAL": 85,
                  "ISSUED_CARD_VOID": 76,
                  "CAPTURE_BALANCE_PAYMENT_REFUND": 69,
                  "COMPLETE_BALANCE_PAYMENT_REFUND": 70,
                  "SWEEP_BIZBANK_MONEY": 74,
                  "REVERSE_SWEEP_BIZBANK_MONEY": 75,
                  "PAYMENT_RISK_TRANSITION": 77,
                  "COST_PLUS_SETTLEMENT": 78,
                  "FORGIVE_DEBT": 79,
                  "APP_FEE": 80,
                  "APP_FEE_REFUND": 81,
                  "RISK_RESERVE_HOLD": 87,
                  "RISK_RESERVE_RELEASE": 88,
                  "DEPOSIT_BIZBANK": 89,
                  "INSTANT_DEPOSIT_BIZBANK": 90,
                  "INITIATE_PAY_IN": 91,
                  "ACCEPT_PAY_IN": 92,
                  "FAIL_PAY_IN": 93,
                  "RECOVERY_OFFSET_TRANSFER_DEBIT": 94,
                  "RECOVERY_OFFSET_TRANSFER_CREDIT": 95,
                  "METI_REBATE": 96,
                  "FOLD_BALANCE": 97,
                  "INTERNAL_TRANSFER_SFS_SAVINGS": 98,
                  "REWARDS_FREE_PROCESSING": 99,
                  "REWARDS_REDEMPTION": 100,
                  "SWEEP_ALLOCATED_MONEY": 101,
                  "REVERSE_SWEEP_ALLOCATED_MONEY": 102,
                  "PERCENTAGE_PROCESSING_ENROLLMENT": 103,
                  "PERCENTAGE_PROCESSING_REPAYMENT": 104,
                  "PERCENTAGE_PROCESSING_DEACTIVATION": 105,
                  "GIFT_CARD_LOAD_FEE": 106,
                  "GIFT_CARD_LOAD_FEE_REFUND": 107,
                  "PAYOUT": 108,
                  "INTERNAL_ADJUSTMENT": 109,
                  "CHECK_ISSUED": 110,
                  "DELIVERY_REIMBURSEMENT": 111,
                  "AUTOMATIC_BITCOIN_BUY": 112,
                  "ONCHAIN_BITCOIN_WITHDRAWAL": 113,
                  "LIGHTNING_PAYMENT": 114,
                  "MARKET_BITCOIN_EXCHANGE": 115,
                  "BLOCK_PROMOTION": 116,
                  "EMPLOYEE_TIP_PAYMENT": 117,
                  "EMPLOYEE_TIP_PAYMENT_REFUND": 118,
                  "ONCHAIN_BITCOIN_DEPOSIT": 119
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.paymentbalances?.nested?.ExternalSource && !$root.nested?.squareup?.nested?.paymentbalances?.nested?.ExternalSource?.nested?.Name) {
  $root.addJSON(jsonData);
}

/**
 * An external source
 *
 * SOURCE ExternalSource @ squareup/paymentbalances/external_sources.proto at 8:1
 */
export const ExternalSource = $root.lookupType('squareup.paymentbalances.ExternalSource');
fixType(ExternalSource);
Builder.createAndAttachToType(ExternalSource);
/**
 * External source names defined by each possible entities that can generate an entry.
 *
 * SOURCE Name @ squareup/paymentbalances/external_sources.proto at 10:3
 */
ExternalSource.Name = $root.lookupEnum('squareup.paymentbalances.ExternalSource.Name').values;